import { z } from "zod";

export const resultSearchSchema = z.object({
	lat: z.number(),
	lon: z.number(),
	date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
	addr: z.string().optional(),
});

export const yearSearchSchema = z.object({
	lat: z.number(),
	lon: z.number(),
	year: z.number().int(),
	addr: z.string().optional(),
});

export const locationSearchSchema = z.object({
	lat: z.number().optional(),
	lon: z.number().optional(),
	year: z.number().int().optional(),
	addr: z.string().optional(),
});

export type ResultSearch = z.infer<typeof resultSearchSchema>;
export type YearSearch = z.infer<typeof yearSearchSchema>;
export type LocationSearch = z.infer<typeof locationSearchSchema>;
